// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import BootstrapVue from 'bootstrap-vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueResource from 'vue-resource'
import VueMatomo from 'vue-matomo'

import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.component('icon', Icon)
Vue.use(VueResource)

if (process.env.NODE_ENV !== 'development') {
  Vue.use(VueMatomo, {
    // Configure your matomo server and site by providing
    host: 'https://matomo.giz.berlin',
    siteId: 11,

    // Changes the default .js and .php endpoint's filename
    // Default: 'piwik'
    trackerFileName: 'matomo',

    // Overrides the autogenerated tracker endpoint entirely
    // Default: undefined
    // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

    // Enables automatically registering pageviews on the router
    router: router
  })
}

Vue.directive('set-class-on-scroll-vertical', {
  inViewport (el) {
    const rect = el.getBoundingClientRect()

    const offsetVertical = window.innerHeight / 4

    return (
      rect.top > offsetVertical &&
        rect.top < (window.innerHeight - offsetVertical)
    ) || (
      rect.bottom > offsetVertical &&
        rect.bottom < (window.innerHeight - offsetVertical)
    )
  },

  bind (el, binding) {
    el.classList.add('invisible')
    el.$onScroll = function () {
      if (binding.def.inViewport(el)) {
        el.classList.add(binding.value)
        el.classList.remove('invisible')
        binding.def.unbind(el, binding)
      }
    }
    document.addEventListener('scroll', el.$onScroll)
  },

  inserted (el) {
    el.$onScroll()
  },

  created (el) {
    el.$onScroll()
  },

  unbind (el) {
    document.removeEventListener('scroll', el.$onScroll)
    delete el.$onScroll
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js